<template>
  <div>
    <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" title="패턴 탐색 내역" width="600px" @close="close">
      <div slot="content">
        <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
            <div class="title-h4">생성 패턴 목록</div>
            <w-header-search-button @click="showSearchHeader"/>
        </el-row>
        <el-row v-loading="loading">
          <el-table-wrapper ref="logTable" :column-default="columnDefault" :data="tableData" :columns="columns" @condition-change="changeCondition" :pagination="true"
          highlight-current-row :show-custom-header="true" :show-search-tool="searchFlag" :limit="limit" :total="total" header-align="center" remote>
          <template slot="patternName-slot" slot-scope="scope">
            <span v-if="isNil(scope.row.mlPatternName)">
              {{patternName.NULL}}
            </span>
            <span v-else>
              {{scope.row.mlPatternName}}
            </span>
          </template>
          </el-table-wrapper>
        </el-row>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import { isNil } from 'lodash';
import msgUtil from '@/utils/message';
import PatternSearchAPI from '@/api/settings/log/lms-pattern-search-setting';

import { columnDefault } from '@/constants/table';
import { patternName } from '../constant/patternDefine';

export default {
  name: 'WLogMlHistPatternPopup',
  props: {
    histId: {
      type: Number,
    },
  },
  data() {
    return {
      patternName,
      loading: false,
      searchFlag: false,
      columnDefault,
      tableData: [],
      start: 0,
      limit: 50,
      total: 0,
      columns: [
        {
          label: '패턴명',
          scopedSlot: 'patternName-slot',
          prop: 'mlPatternName',
          width: '150px',
        },
        {
          label: '패턴',
          prop: 'mlPattern',
          searchable: true,
          remoteProp: 'ml_pattern',
        },
      ],
    };
  },
  methods: {
    isNil,
    showSearchHeader() {
      this.searchFlag = !this.searchFlag;
    },
    changeCondition(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.searchParams = value.searchParams;
      this.loadData();
    },
    setHistPatternName() {
    },
    loadData() {
      this.loading = true;
      const params = {
        histId: this.histId,
        start: this.start,
        limit: this.limit,
        searchParams: this.searchParams,
      };
      PatternSearchAPI.getHistPatternList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '패턴', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    open() {
      this.loading = false;
      this.$refs.slidingPopup.visible = true;
      this.loadData();
      this.$nextTick(() => {
        this.$refs.logTable.setCurrentPage(1);
      });
    },
    close() {
      this.start = 0;
      this.limit = 50;
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Pattern/popup/LogMlHistPatternPopup.vue